const actions = {
  HISTORY_LIST_BEGIN: 'HISTORY_LIST_BEGIN',
  HISTORY_LIST_SUCCESS: 'HISTORY_LIST_SUCCESS',
  HISTORY_LIST_ERR: 'HISTORY_LIST_ERR',


  getHistoryListBegin: () => {
    return {
      type: actions.HISTORY_LIST_BEGIN,
    };
  },

  getHistoryListSuccess: (data) => {
    return {
      type: actions.HISTORY_LIST_SUCCESS,
      data,
    };
  },

  getHistoryListErr: (err) => {
    return {
      type: actions.HISTORY_LIST_ERR,
      err,
    };
  },

};

export default actions;
